
import {
  StatusBar,
  I18nManager,
  View,
  Text,
  StyleSheet,
  Platform, KeyboardAvoidingView
} from 'react-native';

import Config from "./Config";
import * as Updates from 'expo-updates';
import { useFonts } from 'expo-font';
import { NavigationContainer } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';
import * as Linking from 'expo-linking';



import Login from "./src/Pages/Login";
import Splash from "./src/Pages/Splash";
import Code from "./src/Pages/Code";
import Home from "./src/Pages/Home";
import Category from "./src/Pages/Category";

import Lesson from "./src/Pages/Lesson";
import Course from "./src/Pages/Course";
import Buy from "./src/Pages/Buy";
import Profile from "./src/Pages/Profile";
import Exam from "./src/Pages/Exam";
import Examresult from "./src/Pages/Examresult";
import Tickets from "./src/Pages/Tickets";
import Ticket from "./src/Pages/Ticket";
import SendTicket from "./src/Pages/SendTicket";
import About from "./src/Pages/About";
import InfoCourse from "./src/Pages/InfoCourse";
import ExamTamrin from "./src/Pages/ExamTamrin";
import Chat from "./src/Pages/Chat";
import CategoryGroup from "./src/Pages/CategoryGroup";
import Packs from "./src/Pages/Packs";
import Pack from "./src/Pages/Pack";
import Update from "./src/Pages/Update";
import Contact from "./src/Pages/Contact";
import Ref from "./src/Pages/Ref";
import FlashCart from "./src/Pages/FlashCart";
import Words from "./src/Pages/Words";
import Word from "./src/Pages/Word";
import Placement from "./src/Pages/placement";
import StartPlacement from "./src/Pages/StartPlacement";
import Placementresult from "./src/Pages/Placementresult";

const Stack = createStackNavigator();

export default function App() {

  //import font
  const [fontsLoaded,error] = useFonts({
    'yk': require('./assets/fonts/dana.ttf'),
    'ykb': require('./assets/fonts/danabold.ttf'),
  });

  if (Platform.OS !== 'web') {
    if( I18nManager.isRTL){

      //force rtl not work in current  expo dev but work in build suggest : style direction rtl 68290
      I18nManager.forceRTL(false);
      I18nManager.allowRTL(false);
      // Updates.reloadAsync().then();
    }
    if(error !== null){
      //reload not work when progourd active
      // Updates.reloadAsync().then();
    }
  }

  // const prefix = Linking.createURL('/');
  const linking = {
    prefixes: ['himora://'],
    config: {
      screens: {
        About: 'about',
        Buy: 'buy',
        Category: 'category/:categoryid',
      },
    },
  };

  return (
      <>
        {fontsLoaded ?
            <KeyboardAvoidingView   behavior={Platform.OS === "ios" ? "padding" : "height"} style={styles.container}>
              <NavigationContainer
                  linking={linking}
                  presentation="transparentModal">
                <Stack.Navigator  screenOptions={{
                  headerShown : false
                }}>

                  <Stack.Screen name="Splash" component={Splash} />
                  <Stack.Screen name="Login" component={Login} />
                  <Stack.Screen name="Code" component={Code} />

                  <Stack.Screen name="Home" component={Home} />
                  <Stack.Screen name="Category" component={Category} />
                  <Stack.Screen name="CategoryGroup" component={CategoryGroup} />
                  <Stack.Screen name="InfoCourse" component={InfoCourse} />
                  <Stack.Screen name="Lesson" component={Lesson} />
                  <Stack.Screen name="Course" component={Course} />
                  <Stack.Screen name="Buy" component={Buy} />
                  <Stack.Screen name="Profile" component={Profile} />
                  <Stack.Screen name="Exam" component={Exam} />
                  <Stack.Screen name="Examresult" component={Examresult} />
                  <Stack.Screen name="Tickets" component={Tickets} />
                  <Stack.Screen name="Ticket" component={Ticket} />
                  <Stack.Screen name="SendTicket" component={SendTicket} />
                  <Stack.Screen name="About" component={About} />
                  <Stack.Screen name="Contact" component={Contact} />
                  <Stack.Screen name="Ref" component={Ref} />
                  <Stack.Screen name="ExamTamrin" component={ExamTamrin} />
                  <Stack.Screen name="Chat" component={Chat} />
                  <Stack.Screen name="Packs" component={Packs} />
                  <Stack.Screen name="Pack" component={Pack} />
                  <Stack.Screen name="Update" component={Update} />
                  <Stack.Screen name="FlashCart" component={FlashCart} />
                  <Stack.Screen name="Words" component={Words} />
                  <Stack.Screen name="Word" component={Word} />
                  <Stack.Screen name="Placement" component={Placement} />
                  <Stack.Screen name="StartPlacement" component={StartPlacement} />
                  <Stack.Screen name="Placementresult" component={Placementresult} />
                </Stack.Navigator>
                <StatusBar
                    backgroundColor={Config.maincolor}
                    barStyle={'white-content'}
                    style="auto"
                />
              </NavigationContainer>
            </KeyboardAvoidingView>
            :
            <View style={styles.container2}><Text style={styles.text}>در حال لود فونت در صورتی که طول کشید اپ را کامل ببندید و مجدد باز کنید</Text></View>
        }
      </>
  );
}

const styles = StyleSheet.create({
  text : {
    fontFamily : 'yk'
  },

  container: {
    flex: 1,
    backgroundColor: '#fff',
    direction : 'rtl'
  },
  container2: {
    flex: 1,
    backgroundColor: '#fff',
    direction : 'rtl',
    justifyContent  : 'center',
    alignItems: 'center'
  },
});
